import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/img/defaultprofile.jpg'


const _hoisted_1 = { class: "_nodeImage" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  src: _imports_0,
  key: "def"
}
const _hoisted_4 = { class: "_nodeBody" }
const _hoisted_5 = { class: "_nodeFooter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_node = _resolveComponent("node", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: "_nodeContainer",
    style: _normalizeStyle(_ctx.node.offset)
  }, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "_upperAnchor" }, null, -1)),
    _createElementVNode("div", {
      class: _normalizeClass(["_node", _ctx.node.role]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onNodeClick && _ctx.onNodeClick(...args)), ["stop","prevent"]))
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.node.image)
            ? (_openBlock(), _createElementBlock("img", {
                src: _ctx.node.image.publicUrl,
                key: "img"
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3)),
          _createElementVNode("div", {
            class: _normalizeClass(["_nodeImageText", { 'text-orange': _ctx.node.type == 'Customer' || _ctx.node.type == 'Lead', 'text-green': _ctx.node.type == 'Operator' }])
          }, _toDisplayString(_ctx.node.role), 3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(_ctx.node.completeName), 1),
          _createElementVNode("div", null, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-cyan" }, "Qualifica:", -1)),
            _cache[2] || (_cache[2] = _createTextVNode()),
            _createElementVNode("b", null, _toDisplayString(_ctx.node.qualification.qualificationCode), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-cyan" }, "Punti:", -1)),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createElementVNode("b", null, _toDisplayString(_ctx.node.qualification.totalPoints), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-cyan" }, "Ref: ", -1)),
            _createElementVNode("b", null, _toDisplayString(_ctx.node.referralCode), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["_nodeChildren", { _shown: _ctx.children.length > 0 }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (item, i) => {
        return (_openBlock(), _createBlock(_component_node, {
          key: i,
          node: item,
          class: _normalizeClass({ 'disabled': item.hide, '_singleNode': _ctx.children.length == 1 }),
          showFilters: _ctx.showFilters,
          onClosed: _ctx.showSiblings,
          onOpened: ($event: any) => (_ctx.hideSiblings(item)),
          allowNavigation: _ctx.allowNavigation
        }, null, 8, ["node", "class", "showFilters", "onClosed", "onOpened", "allowNavigation"]))
      }), 128))
    ], 2)
  ], 4))
}